'use client'
import dynamic from 'next/dynamic'

// Loaded on demand. MarkdownRenderer pulls react-markdown plus the whole
// unified/micromark/parse5 pipeline (~318 KB raw, ~102 KB brotli). Imported
// statically from a client component it lands in the SHARED client graph, so
// every storefront page — homepage, blog, PDP — downloaded it even though only
// the booking flow renders markdown in the browser. `dynamic()` here is a real
// async chunk because this is a genuine client→client edge with no barrel in
// between; the same call inside a Server Component, or through the shared-ui
// barrel, is a measured no-op.
const MarkdownRenderer = dynamic(() =>
  import('@/components/MarkdownRenderer').then((m) => m.MarkdownRenderer)
)

/** Display-only. No persisted completion — `content` is a soft, booking-level
 *  step (STEP_META), so booking_flow_progress takes no writes for it. */
export function ContentStep({ title, markdown }: { title?: string; markdown: string }) {
  return (
    <div className="rounded-md border border-[var(--color-border,#e2e6e1)] p-4">
      {title && <p className="font-medium text-[var(--color-text-primary,#1f2723)]">{title}</p>}
      <div className={title ? 'mt-2' : undefined}>
        <MarkdownRenderer markdown={markdown} />
      </div>
    </div>
  )
}
